<template>
    <div class="app-inner" id="orderDetail">
          <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
            </div>
             <!-- 进度条 -->
           <div class="steps">
            <el-steps :active="type" align-center>
      <el-step title="提交订单" icon="el-icon-tickets" :description="infoList.createTime" ></el-step>
       <el-step title="支付订单" icon="icon-al-transanction" :description="infoList.updateTime && type == 3 ? infoList.updateTime : '未支付'"></el-step>
       <el-step title="订单完成" icon="el-icon-check" :description=" infoList.updateTime && type == 3 ? infoList.updateTime : ''"></el-step>
                    </el-steps>
           
           </div>
               <div class="edit-from">
                       <div class="public-tit flex align-cen">
            <div class="public-tit-list" style="color:red">
               
                <span >
                     当前订单状态：{{type==1 ? '已取消': type == 2 ? '待付款' : '已完成'}}
                </span>
            </div>
            <div class="mft">
             <div class="public-btn-small flex align-cen">
              <div class="public-btn-small-primary" @click="openXg" v-if="type == 2">
                修改费用信息
            </div>
             <div class="public-btn-small-plan" v-if="type == 2" @click="remarkFun(1)">
                关闭订单
            </div>
            <div class="public-btn-small-plan" @click="remarkFun(0)">
                备注订单
            </div>
            
            </div>
            </div>
        </div>
             <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-user-fill"></i>  基本信息
            </div>
        </div>
           <el-table
            :data="orderUserInfo"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
            <el-table-column
            prop="id"
            label="订单编号"
           align="center"
             >
            </el-table-column>
           <el-table-column
            label="官网分类"
           align="center"
             >
               <template slot-scope="scope">
               {{$util.offType(scope.row.officialType)}}
               </template>
            </el-table-column>
            <el-table-column
            label="支付方式"
           align="center"
             >
             <template slot-scope="scope">
               {{scope.row.payType == 1 ? '支付宝' : scope.row.payType == 2 ? '微信' : scope.row.payType == 3 ? '对公转账' : '未支付' }}
             </template>
            </el-table-column>
            
            <el-table-column
            label="订单分类"
           align="center"
             >
               <template slot-scope="scope">
                {{scope.row.orderType == 1 ? '应用订单' : '课程订单'}}
               </template>
            </el-table-column>
            <el-table-column
            label="订单可得积分"
           align="center"
             >
             <template slot-scope="scope">
                {{scope.row.integrationAmount || '暂无'}}
             </template>
            </el-table-column>
            <el-table-column
            label="活动信息"
           align="center"
             >
              <template slot-scope="scope">
                {{scope.row.integration || '暂无'}}
             </template>
            </el-table-column>
           </el-table>
                <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-qiyeguanli"></i>  购买企业信息
            </div>
        </div>
         <el-table
            :data="buissInfo"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
             <el-table-column
            prop="id"
            label="下单企业ID"
           align="center"
             >
            </el-table-column>
             <el-table-column
            prop="name"
            label="下单企业名称"
           align="center"
             >
            </el-table-column>
             <el-table-column
            label="下单企业全称"
           align="center"
             >
             <template slot-scope="scope">
                {{scope.row.fullName || scope.row.name}}
             </template>
            </el-table-column>
              <el-table-column
            label="企业税号"
           align="center"
             >
               <template slot-scope="scope">
               {{scope.row.taxId || '暂无'}}
            </template>
              </el-table-column>
               <el-table-column
            label="总消费金额"
           align="center"
             >
            <template slot-scope="scope">
               ¥{{infoList.businessAmount}}
            </template>
              </el-table-column>
               <el-table-column
            label="操作"
           align="center"
             >
            <template slot-scope="scope">
                <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="detail(scope.row)">查看企业详情</el-button>
            </template>
              </el-table-column>
         </el-table>
              <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-applicationgroup"></i>  商品信息
            </div>
        </div>
          <el-table
            :data="apploation"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            v-if="infoList.appSku"
            >
         <el-table-column
            label="应用图片"
           align="center"
             >
            <template slot-scope="scope">
               <img :src="scope.row.pic" alt="" style="width:80px">
            </template>
              </el-table-column>
                  <el-table-column
            prop="id"
            label="应用ID"
           align="center"
             >
            </el-table-column>
            <el-table-column
            prop="appName"
            label="应用名称"
           align="center"
             >
            </el-table-column>
            <el-table-column
            prop="name"
            label="SKU"
           align="center"
             >
            </el-table-column>
              <el-table-column
            label="数量"
           align="center"
             >
             <template>
                1 
             </template>
            </el-table-column>
             <el-table-column
            label="小计"
           align="center"
             >
             <template slot-scope="scope">
               ¥{{scope.row.salePrice}}
             </template>
            </el-table-column>
          </el-table>
                    <el-table
            :data="apploation"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            v-if="infoList.courseSku"
            >
         <el-table-column
            label="课程图片"
           align="center"
             >
            <template slot-scope="scope">
               <img :src="scope.row.logo" alt="" style="width:80px">
            </template>
              </el-table-column>
                  <el-table-column
            prop="id"
            label="课程ID"
           align="center"
             >
            </el-table-column>
            <el-table-column
            prop="title"
            label="课程名称"
           align="center"
             >
            </el-table-column>
            <el-table-column
            prop="name"
            label="SKU"
           align="center"
             >
            </el-table-column>
              <el-table-column
            label="数量"
           align="center"
             >
             <template>
                1 
             </template>
            </el-table-column>
             <el-table-column
            label="小计"
           align="center"
             >
             <template slot-scope="scope">
               ¥{{scope.row.salePrice}}
             </template>
            </el-table-column>
          </el-table>
          <div class="allprice">合计：¥{{totpricei}}</div>
               <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-transanction"></i>  费用信息
            </div>
        </div>
          <el-table
            :data="priceInfo"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
             <el-table-column
            label="合计"
           align="center"
             >
             <template slot-scope="scope">
               ¥{{scope.row.payAmount}}
             </template>
            </el-table-column>
              <el-table-column
            label="优惠券"
           align="center"
             >
             <template slot-scope="scope">
               -¥{{scope.row.couponAmount || '0.00'}}
             </template>
            </el-table-column>
                  <el-table-column
            label="积分抵扣"
           align="center"
             >
             <template slot-scope="scope">
               -¥{{scope.row.integrationAmount || '0.00'}}
             </template>
            </el-table-column>
              <el-table-column
            label="活动优惠"
           align="center"
             >
             <template slot-scope="scope">
               -¥{{scope.row.promotionAmount || '0.00'}}
             </template>
            </el-table-column>
             <el-table-column
            label="折扣金额"
           align="center"
             >
             <template slot-scope="scope">
               -¥{{scope.row.discountAmount || '0.00'}}
             </template>
            </el-table-column>
             <el-table-column
            label="订单总金额"
           align="center"
             >
             <template slot-scope="scope">
              <span style="color:red"> ¥{{scope.row.orderAmount || '0.00'}}</span>
             </template>
            </el-table-column>
            <el-table-column
            label="应付款金额"
           align="center"
             >
             <template slot-scope="scope">
              <span style="color:red"> ¥{{scope.row.payAmount}}</span>
             </template>
            </el-table-column>
          </el-table>
               <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-cog"></i>  操作信息
            </div>
        </div>
             <el-table
            :data="infoList.orderOperationList"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
              <el-table-column
            label="操作者"
           align="center"
             >
             <template slot-scope="scope">
              {{scope.row.operator || '用户'}}
             </template>
            </el-table-column>
               <el-table-column
               prop="operateTime"
            label="操作时间"
           align="center"
           width="200"
             >
               </el-table-column>
                 <el-table-column
               prop="orderStatus"
            label="订单状态"
           align="center"
             >
               </el-table-column>
                <el-table-column
               prop="payStatus"
            label="付款状态"
           align="center"
             >
               </el-table-column>
                 <el-table-column
               prop="remark"
            label="备注"
           align="center"
             >
               </el-table-column>
             </el-table>
            </div>
        <el-dialog
        title="修改费用信息"
      :visible.sync="centerDialogVisible"
      width="50%"
      :append-to-body="true"
      center
        >
         <div class="editPrice" v-if="centerDialogVisible">
           <el-table
            :data="priceInfo"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
             <el-table-column
            label="合计"
           align="center"
             >
             <template slot-scope="scope">
               ¥{{surePrice}}
             </template>
            </el-table-column>
              <el-table-column
            label="优惠券"
           align="center"
             >
             <template slot-scope="scope">
               -¥{{scope.row.couponAmount || '0.00'}}
             </template>
            </el-table-column>
                  <el-table-column
            label="积分抵扣"
           align="center"
             >
             <template slot-scope="scope">
               -¥{{scope.row.integrationAmount || '0.00'}}
             </template>
            </el-table-column>
              <el-table-column
            label="活动优惠"
           align="center"
             >
             <template slot-scope="scope">
               -¥{{scope.row.promotionAmount || '0.00'}}
             </template>
            </el-table-column>
             <el-table-column
            label="折扣金额"
           align="center"
           width="200"
             >
             <template slot-scope="scope">
              <!-- {{scope.row.discountAmount || '0.00'}} -->
            <div class="flex align-cen justify-content-cen">
                 <span style="margin-right:10px">-¥</span><el-input  v-model="price"
                 @change="changeDis(price)"
                 :placeholder="scope.row.discountAmount"
                  clearable style="width:120px;border:none"
                  ></el-input>
            </div>
             </template>
            </el-table-column>
             <el-table-column
            label="订单总金额"
           align="center"
             >
             <template slot-scope="scope">
              <span style="color:red"> ¥{{scope.row.orderAmount || '0.00'}}</span>
             </template>
            </el-table-column>
            <el-table-column
            label="应付款金额"
           align="center"
             >
             <template slot-scope="scope">
              <span style="color:red"> ¥{{surePrice}}</span>
             </template>
            </el-table-column>
          </el-table>
             <div class="public-btn-small flex align-cen" style="justify-content:center;padding-left:0;margin-top:26px">
             <div class="public-btn-small-plan"  @click="centerDialogVisible = false" style="margin-left:0">
                取消
            </div>
              <div class="public-btn-small-primary" style="margin-left:16px" @click="updateOrder">
                确定
            </div>
            </div>
          </div>  
     </el-dialog>
    </div>
</template>
<script>
import { orderDetail,closeOrder,updateOrderFee} from "@/api/index/index" // 订单详情、（关闭、备注）订单、修改订单
export default {
    name:'orderDetail',
    data () {
        return {
            type:0,
            infoList:{},
            orderUserInfo:[],
            buissInfo:[],
            apploation:[],
            priceInfo:[],
            totpricei:'',
            centerDialogVisible:false,
            price:'',
            surePrice:'',
            isClick:false,
        }
    },
    created() {
        this.getDetail()
    },
    methods: {
      // 打开修改费用
      openXg(){
        this.centerDialogVisible = true
        this.price = ""
        this.getDetail()
      },
      // input金额信息发生改变时
      changeDis(e){
        if(isNaN(Number(e))) return this.$util.Notifi('请正确输入价格','error','fa-exclamation-circle'),this.isClick = false
        if(Number(this.priceInfo[0].payAmount - e) <= 0) return this.$util.Notifi('应付金额不能小于0或等于0，请重新输入','error','fa-exclamation-circle'),this.isClick = false
        this.isClick = true
        this.surePrice =  Number(this.priceInfo[0].payAmount - e).toFixed(2) 
      },
      // 修改金额信息操作
      updateOrder(){
        if(!this.isClick) return
         if(isNaN(Number(this.price))) return
         if(!this.price) return this.$util.Notifi('请输入折扣价格','error','fa-exclamation-circle')
        //  if(Number(this.price ) == Number(this.surePrice)) return this.$util.Notifi('应付金额为0，请重新输入','error','fa-exclamation-circle')
         updateOrderFee({
          id:this.$route.query.id,
          orderAmount:this.priceInfo[0].orderAmount,
          payAmount:this.priceInfo[0].payAmount,
          discountAmount:this.price
         })
         .then(res =>{
          if(res.code == 0){
            this.$util.Notifi('修改成功','success','fa-check');
            this.getDetail()
            this.centerDialogVisible = false
          }else{
            this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
          }
         })
         .catch(err =>{
          this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
         })
      },
      // 备注
      remarkFun(type){
          this.$prompt('操作备注', type==0 ? '备注订单' : '关闭订单', {
          inputPlaceholder:'处理备注【必填】',
          inputType:'textarea',
          inputPattern:/^[0-9a-zA-Z\u4E00-\u9FA5\uf900-\ufa2d·s]{1,50}$/,
          inputErrorMessage: '请输入1-50字符',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
            this.remarkClose(value,type)
        }).catch(() => {     
        });
      },
      remarkClose(value,type){
        let params = type == 0 ? {id:this.$route.query.id,remark:value} : {id:this.$route.query.id,remark:value,orderStatus:0}
        closeOrder(params)
        .then(res => {
          if(res.code == 0){
            this.$util.Notifi('操作成功','success','fa-check');
            this.getDetail()
          }else{
            this.$util.Notifi('操作失败','error','fa-exclamation-circle')
          }
        })
        .catch(err =>{
          this.$util.Notifi('操作失败','error','fa-exclamation-circle')
        })
      },
        // 打开企业详情
        detail(data){
            this.$router.push({
            name: "businessDetail",
            query:{
                id:data.id,
                type:3,
                redicetId:this.$route.query.id
            }
           })
        },
        getDetail(){
            orderDetail({id:this.$route.query.id})
            .then(res => {
                this.infoList = res.data
                 this.type = Number(parseInt(res.data.orderStatus) + 1)
                 this.totpricei = res.data.appSku ? res.data.appSku.salePrice : res.data.courseSku ? res.data.courseSku.salePrice : ''
                 this.surePrice = res.data.payAmount
                 this.orderUserInfo = [
                    {
                        id:res.data.id,
                        payType:res.data.payType,
                        orderType:res.data.orderType,
                        integrationAmount:res.data.integrationAmount,
                        integration:res.data.integration,
                        officialType:res.data.officialType
                    }
                 ]
                 this.buissInfo = [
                    res.data.business
                 ]

                if(res.data.appSku){
                     this.apploation = [
                    Object.assign(res.data.application,res.data.appSku)
                 ]
                }else if(res.data.courseSku){
                     this.apploation = [
                    Object.assign(res.data.course,res.data.courseSku)
                 ]       
                }else{
                   this.apploation = [ ]
                }
                console.log(this.apploation)
                this.priceInfo = [
                    {
                      orderAmount:res.data.orderAmount,
                      couponAmount:res.data.couponAmount,
                      integrationAmount:res.data.integrationAmount,
                      discountAmount:res.data.discountAmount,
                      payAmount:res.data.payAmount,
                      promotionAmount:res.data.promotionAmount  
                    }
                ]
            })
            .catch(err => {})
        },
        // 返回
        reback(){
             this.$router.push('/Transaction')
        },
    },
}
</script>
<style lang="scss" scoped>
#orderDetail{
    .edit-from{
            margin-bottom: 44px;
        .public-tit{
            margin: 20px 0;
        }
        .allprice{
            padding: 20px 0;
            text-align: right;
            color: red;
            padding-right: 20px;
            border: 1px solid #EBEEF5;
            border-top: none;
        }
    }
}
::v-deep{
    .el-step__head.is-finish{
        color: #155bd4;
        border-color:#155bd4 ;
        .el-step__icon.is-icon{
    border: 3px solid #155bd4;
        }
    }
    .el-step__head.is-process{
          .el-step__icon.is-icon{
    border: 3px solid #303133;
        }
    }
      .el-step__icon.is-icon{
    width: 60px;
    border: 3px solid #C0C4CC;
    border-radius: 60px;
    height: 60px;
    
        }
    .el-step__title.is-finish,.el-step__description.is-finish{
        color: #303133;
        font-weight: bold;
    }
.el-step.is-horizontal .el-step__line{
    top: 30px;
}
}
</style>